var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProhibited(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "130.32 130.66 938.64 938.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m600 1069.3c108.57-0.082031 213.76-37.809 297.64-106.75 83.879-68.941 141.26-164.84 162.37-271.34 21.105-106.5 4.6289-217.03-46.617-312.75s-134.1-170.71-234.44-212.19c-100.34-41.484-211.95-46.898-315.83-15.312-103.88 31.582-193.6 98.203-253.86 188.52-60.27 90.312-87.355 198.73-76.652 306.77s58.539 209.04 135.36 285.77c43.574 43.629 95.336 78.215 152.32 101.77 56.98 23.562 118.06 35.629 179.72 35.508zm0-842.64c93.992-0.082032 184.56 35.305 253.59 99.094 69.035 63.785 111.46 151.28 118.8 244.98 7.3359 93.707-20.961 186.73-79.23 260.48l-524.4-524.4c65.855-51.996 147.33-80.238 231.24-80.16zm-298.44 148.8 522.96 522.84c-71.906 54.066-160.91 80.363-250.66 74.047-89.742-6.3203-174.19-44.82-237.81-108.43-63.625-63.605-102.14-148.04-108.48-237.79-6.3359-89.742 19.938-178.75 73.988-250.67z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProhibited);
export default __webpack_public_path__ + "static/media/icon-prohibited.5bf5c2d324b63e1fb56a7cbf82f87df4.svg";
export { ForwardRef as ReactComponent };